import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import { appAlert, appConfirm } from '../../lib/dialogs';
import { beginDialogAction } from '../../lib/dialogAction';

@withText(props => ({
    documentTitle: <Text id='document.title'>Document</Text>,
}))
@observer
class DocumentEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('document', ['Document info', 'Document validity', 'Document weapon license', 'Document ticket', 'Document attachments']),
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id } = props;
        const { documentStore } = this.props.stores;
        if (emptyFirst) {
            documentStore.updateKeyValue('document', {});
            documentStore.updateKeyValue('newDocument', {});
        }
        if (id) {
            await documentStore.load(id, false, {});
        }
    }

    createDocument = async () => {
        const { callback = () => {}, isNew, drawerLevel } = this.props;
        const { documentStore, appState } = this.props.stores;
        const { newDocument } = documentStore;

        if (!newDocument.title || !newDocument.documentType) {
            (await appAlert('Title and document type are required'));
            return;
        }

        if (isNew) {
            const response = await documentStore.insert(newDocument);
            documentStore.updateKeyValue('document', response?.data?.document);
            documentStore.updateKeyValue('newDocument', {});
            callback();
            appState.toggleDrawer(false, drawerLevel);
        }
    }

    deleteDocument = async () => {
        const dialogAction = beginDialogAction(this, 'deleteDocument', () => [
            this.props?.stores?.documentStore?.document?.id,
        ]);
        if (!dialogAction) return false;
        try {
            const { callback = () => {}, drawerLevel } = this.props;
            const { documentStore, appState } = this.props.stores;
            const { document } = documentStore;

            if (!((await appConfirm('Are you sure you want to delete this document?')) && dialogAction.isCurrent())) {
                return;
            }

            await documentStore.save({ id: document.id, offline: 1 }, false, false);
            callback();
            appState.toggleDrawer(false, drawerLevel);
        } finally {
            dialogAction.finish();
        }
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, documentStore } = this.props.stores;
        const { user } = userStore;
        const { newDocument, document } = documentStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        const currentObject = isNew ? newDocument : document;

        return (
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='document.new'>New Document</Text> : <Text id='document.edit'>Edit Document</Text>}
                    </div>

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={documentStore}
                                objectName={isNew ? 'newDocument' : 'document'}
                                isNew={isNew}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                hideFilterToolbar={true}
                            />
                        </div>
                    </div>

                    {/* Delete button for existing documents */}
                    {!isNew && document.id && (
                        <div class='w-100 d-flex flex-column justify-content-start mt-4 px-3'>
                            <button
                                type='button'
                                class='btn btn-outline-danger rounded-pill'
                                onClick={this.deleteDocument}
                            >
                                <i class='fa-solid fa-trash me-2' />
                                <Text id='document.delete'>Delete Document</Text>
                            </button>
                        </div>
                    )}
                </div>

                {isNew && (
                    <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style='bottom: 0; left: 0;'>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createDocument}>
                            <i class='fa-solid fa-plus me-2' />
                            <Text id='document.create'>Create Document</Text>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default DocumentEdit;
